<form [formGroup]="form" (ngSubmit)="model ? update() : create()">
    <div class="form-row mt-3">
        <div class="form-field">
            <input pInputText type="text" formControlName="clave" class="form-control" [placeholder]="'Ingrese clave forma de pago'"
                [disabled]="model">
            <label>Clave forma de pago</label>
        </div>
    </div>

    <div class="form-row">
        <div class="form-field">
            <input pInputText type="text" formControlName="descripcion" class="form-control"
                [placeholder]="'Ingrese descripción'">
            <label>Descripción</label>
        </div>
    </div>

    <div>
        <div>
            <div class="checkbox-field">
                <input type="checkbox" formControlName="pedir_Referencia">
                <label>Pedir referencia</label>
            </div>
        </div>
    </div>

    <div>
        <div>
            <div class="checkbox-field">
                <input type="checkbox" formControlName="efectivo">
                <label>Efectivo</label>
            </div>
        </div>
    </div>

    <div>
        <div>
            <div class="checkbox-field">
                <input type="checkbox" formControlName="pedir_Autorizacion">
                <label>Pedir autorización</label>
            </div>
        </div>
    </div>

    <div class="button-section">
        <button mat-flat-button class="btn-success btn-menu" (click)="model ? update() : create()"
            [disabled]="!form.valid || loading">
            <mat-icon>save</mat-icon>
            {{ model ? 'Actualizar' : 'Guardar' }}
        </button>
    </div>
</form>

<style>
    :host ::ng-deep .form-row {
        display: flex;
        flex-direction: row;
        margin-bottom: 1rem;
    }

    :host ::ng-deep .form-field {
        flex: 1;
        display: flex;
        flex-direction: column-reverse;
        position: relative;
    }

    :host ::ng-deep .form-control {
        width: 100%;
        padding: 0.5rem;
        font-size: 1rem;
        border: 1px solid #ced4da;
        border-radius: 4px;
        background: #fff;
        transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
    }

    :host ::ng-deep .form-control:disabled {
        background: #e0e0e0 !important;
        color: #555 !important;
        opacity: 1 !important;
    }

    :host ::ng-deep .form-field label {
        font-size: 0.85rem;
        color: #6c757d;
        margin-bottom: 0.25rem;
    }

    :host ::ng-deep .button-section {
        display: flex;
        justify-content: flex-end;
        gap: 1rem;
        margin-top: 1.5rem;
    }

    :host ::ng-deep .checkbox-field {
        display: flex;
        align-items: center;
        gap: 0.5rem;
    }

    :host ::ng-deep .checkbox-field input[type="checkbox"] {
        width: 16px;
        height: 16px;
        margin: 0;
        cursor: pointer;
    }

    :host ::ng-deep .checkbox-field label {
        margin: 0;
        font-size: 0.85rem;
        color: #6c757d;
        cursor: pointer;
    }
</style> 